import React, { useState } from "react";

import CustomerInfo from "./customerInfo";

export default function CustomerAnalytics() {
  const [userList] = useState([]);
  const [projectList] = useState([]);

   return (
    <div>
      {userList.length > 0 && projectList.length > 0 && (
        <CustomerInfo
          userList={userList}
          projectList={projectList}
        ></CustomerInfo>
      )}
    </div>
  );
}
